import { UseQueryOptions } from '@tanstack/react-query';
import { RichTextEditorProps } from 'components/editor/RichTextEditor.types';
import useAppQuery from 'hooks/useAppQuery';

export const FETCH_PREVIEW_CONTENT_BASE_QUERY_KEY = 'preview-content';

type ReactQueryOptions = Omit<
  UseQueryOptions<string | undefined>,
  'queryKey' | 'queryFn'
>;

type UseFetchPreviewContentArgs = {
  content: string;
  toolbarSettings: RichTextEditorProps['toolbarSettings'];
} & ReactQueryOptions;

const useFetchPreviewContent = ({
  content,
  toolbarSettings,
  enabled = true,
  ...options
}: UseFetchPreviewContentArgs) => {
  return useAppQuery<string | undefined>({
    queryKey: [FETCH_PREVIEW_CONTENT_BASE_QUERY_KEY, 'detail', content],
    queryFn: async () =>
      toolbarSettings?.features?.preview?.loadPreview(content),
    enabled:
      enabled &&
      !!toolbarSettings?.enabled &&
      !!toolbarSettings.features?.preview,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchPreviewContent;
